import { MouseEvent } from 'react';

import clsx from 'clsx';

import LeftIcon from '@/public/assets/ui-icons/left.svg';
import RightIcon from '@/public/assets/ui-icons/right.svg';

interface ScrollButtonProps {
  rotate: 'left' | 'right';
  move: (rotate: 'left' | 'right') => void;
  isActive: boolean;
  'data-testid'?: string;
}

const ACTIVE_CLASSES = 'shadow-sm shadow-grey-300/40 bg-white lg:hover:text-blue-500';
const INACTIVE_CLASSES = 'bg-blue-grey-500/10 dark:bg-blue-grey-500/40';

const ScrollButton = ({ rotate, move, isActive, 'data-testid': dataTestid }: ScrollButtonProps) => {
  const setMove = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    move(rotate);
  };

  const DirectionIcon = rotate === 'left' ? LeftIcon : RightIcon;
  const iconClassName = rotate === 'left' ? 'mr-px' : 'ml-px';

  return (
    <button
      className={clsx(
        'hidden h-10 w-10 items-center justify-center self-center rounded-full text-blue-grey-500 lg:flex',
        isActive ? ACTIVE_CLASSES : INACTIVE_CLASSES
      )}
      onClick={(e) => setMove(e)}
      disabled={!isActive}
      data-testid={dataTestid}
    >
      <DirectionIcon className={clsx('h-[21px]', iconClassName)} />
    </button>
  );
};

export default ScrollButton;
